import Button from '@risksmart-app/components/src/button';
import type { Ref } from 'react';
import { useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import { useIsFeatureVisibleToOrg } from 'src/utils/featureFlags';

import { useDashboardWidgetSettings } from '../../../../context/useDashboardWidgetSettings';
import type { WidgetRef } from '../../types';
import { EditorModal } from './EditorModal';
import { RichTextWidgetCloudscape } from './RichTextWidget.cloudscape';
import { RichTextWidgetHighcharts } from './RichTextWidget.highcharts';
import type { WidgetSettings } from './widgetSettingsSchema';

export const RichTextWidget = (_props: unknown, ref: Ref<WidgetRef>) => {
  const [settings, setSettings] = useDashboardWidgetSettings<WidgetSettings>();
  const [showModal, setShowModal] = useState(false);
  const highchartsEnabled = useIsFeatureVisibleToOrg('highcharts');

  const { t } = useTranslation('common', {
    keyPrefix: 'dashboard.widgets.richText',
  });

  useImperativeHandle(ref, () => ({
    openSettings: () => setShowModal(true),
  }));

  const handleSave = async (data: WidgetSettings) => {
    setSettings({ ...data, content: sanitizeHtml(data.content) });
  };

  const Widget = highchartsEnabled
    ? RichTextWidgetHighcharts
    : RichTextWidgetCloudscape;

  return (
    <>
      {showModal && (
        <EditorModal
          onDismiss={() => setShowModal(false)}
          onSave={handleSave}
        />
      )}
      <div className={'rich-text-widget'} style={{ height: '100%' }}>
        {!settings ||
        (settings.allowOwnershipFiltering && !settings.content) ? (
          <div className={'flex flex-col justify-center items-center'}>
            <h3 className={'m-0'}>{t('not_configured_title')}</h3>
            <p>{t('not_configured')}</p>
            <Button onClick={() => setShowModal(true)}>
              {t('configure_button')}
            </Button>
          </div>
        ) : (
          <Widget html={sanitizeHtml(settings?.content ?? '')} />
        )}
      </div>
    </>
  );
};
